import Vue from 'vue'
import config from '@/configurations/config-environment'
import arrayUtils from '@/utils/arrayUtils'
import { BaseService } from '../baseService'

const dataws = config.apis.dataws

export class GaugingTubeService extends BaseService {
  getGaugingTubes(projectID, measurementpointGuid) {
    const authorisation = this.getAuthorizationObject()
    const languageCode = this.getLangCodeLongFromShort(authorisation.Language)
    const data = {
      Authorisation: authorisation,
      LanguageCode: languageCode,
      WebserviceVersion: '1.0',
      TypeOfExport: 'Export_FIELD_JSON_v1_0_0',
      Parameters: [
        {
          ParameterType: 'ExportFormat',
          StringValue: 'json'
        },
        {
          ParameterType: 'ProjectID',
          StringValue: projectID.toString(),
          FloatValue: projectID.toString()
        },
        {
          ParameterType: 'MeasurementPointGuid',
          StringValue: measurementpointGuid.toString()
        }
      ],
      logFormat: 'XML'
    }

    return Vue.http
      .post(`${dataws}ITWDataRestService_V1_0/GetGaugingTubes`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((resp) => {
        this.evaluateResponse(resp, 'getGaugingTubes')

        const veldData = JSON.parse(resp.data.Files[0].FileContent).VeldData
        const tblMeasurementPoints = arrayUtils.formatArray(veldData.tblMeasurementPoints)
        const tblFilterTubes = arrayUtils.formatArray(veldData.tblFilterTubes)

        return {
          tblMeasurementPoints,
          tblGaugingTubes: tblFilterTubes
        }
      })
  }

  getGaugingTubesXml(projectID, measurementpointGuid) {
    const authorisation = this.getAuthorizationObject()
    const languageCode = this.getLangCodeLongFromShort(authorisation.Language)
    const data = {
      Authorisation: authorisation,
      LanguageCode: languageCode,
      WebserviceVersion: '1.0',
      TypeOfExport: 'Export_TI_v1_0_0',
      Parameters: [
        {
          ParameterType: 'ExportFormat',
          StringValue: 'json'
        },
        {
          ParameterType: 'ProjectID',
          StringValue: projectID.toString(),
          FloatValue: projectID.toString()
        },
        {
          ParameterType: 'MeasurementPointGuid',
          StringValue: measurementpointGuid.toString()
        }
      ],
      logFormat: 'XML'
    }

    return Vue.http
      .post(`${dataws}ITWDataRestService_V1_0/GetGaugingTubes`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((resp) => {
        // TODO: #15991
        // Cannot get correct data via Field JSON export so can't evaluate
        // this.evaluateResponse(resp, 'getGaugingTubes')

        const parser = new DOMParser()

        const doc = parser.parseFromString(resp.data.Files[0].FileContent, 'text/xml')

        const gaugingTubesXml = doc.querySelectorAll('ITWBMPE0')

        const results = []

        gaugingTubesXml.forEach((gaugingTubeXml) => {
          results.push({
            FtID: gaugingTubeXml.querySelector('IDPEILBUIS').textContent,
            FtGuid: gaugingTubeXml.querySelector('PEGUID').textContent
          })
        })

        return results
      })
  }

  setGaugingTubes(prid, mpguid, gaugingTubes) {
    const data = {
      data: {
        PrID: prid,
        MpGuid: mpguid,
        FilterTubes: gaugingTubes,
        Authorisation: this.getAuthorizationObject()
      },
      action: 'UPDATE'
    }

    return Vue.http
      .post(`${dataws}ITWDataRestService_V1_0/SetGaugingTubes`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((resp) => {
        if (resp.status !== 200 || resp.data.ResultCode !== 'Import_Succes') throw new Error(`Unable to save gauging tubes. ${resp.data.ResultMessage}`)

        let tblGaugingTubes = JSON.parse(resp.data.FileContent).VeldData.tblFilterTubes
        tblGaugingTubes = arrayUtils.formatArray(tblGaugingTubes)
        return tblGaugingTubes
      })
  }

  createGaugingTube(projectId, measurementPointGuid, gaugingTubes) {
    const data = {
      data: {
        PrID: projectId,
        MpGuid: measurementPointGuid,
        FilterTubes: gaugingTubes,
        Authorisation: this.getAuthorizationObject()
      },
      action: 'INSERT'
    }

    return Vue.http
      .post(`${dataws}ITWDataRestService_V1_0/SetGaugingTubes`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((resp) => {
        this.evaluateResponse(resp, 'createGaugingTube')

        let tblGaugingTubes = JSON.parse(resp.data.FileContent).VeldData.tblFilterTubes
        tblGaugingTubes = arrayUtils.formatArray(tblGaugingTubes)
        return tblGaugingTubes
      })
  }

  updateGaugingTube(projectId, measurementPointGuid, gaugingTubes) {
    const data = {
      data: {
        PrID: projectId,
        MpGuid: measurementPointGuid,
        FilterTubes: gaugingTubes,
        Authorisation: this.getAuthorizationObject()
      },
      action: 'UPDATE'
    }

    return Vue.http
      .post(`${dataws}ITWDataRestService_V1_0/SetGaugingTubes`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((resp) => {
        this.evaluateResponse(resp, 'updateGaugingTube')

        let tblGaugingTubes = JSON.parse(resp.data.FileContent).VeldData.tblFilterTubes
        tblGaugingTubes = arrayUtils.formatArray(tblGaugingTubes)
        return tblGaugingTubes
      })
  }

  deleteGaugingTube(prID, mpGuid, ftGuid) {
    const data = {
      data: {
        PrID: prID,
        MpGuid: mpGuid,
        FtGuid: ftGuid,
        Authorisation: this.getAuthorizationObject()
      },
      action: 'DELETE'
    }

    return Vue.http
      .post(`${dataws}ITWDataRestService_V1_0/SetGaugingTubes`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((resp) => {
        this.evaluateResponse(resp, 'deleteGaugingTube')

        return true
      })
  }

  evaluateResponse(response, requestName) {
    if (
      response.status !== 200 ||
      !response.data ||
      (response.data.ResultCode !== 'Import_Succes' && response.data.ResultCode !== 'Export_Succes') ||
      (response.data.ResultMessage !== null && response.data.ResultMessage.toLowerCase().includes('error'))
    ) {
      throw new Error(`Request ${requestName} failed with message '${response.data.ResultMessage}'`)
    }
  }
}
